import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Cliente/cambiarEstadoClienteSeleccion`, method: 'POST', body: values, token: token})
}